import { motion } from "framer-motion";

// Radial expanding circle in the world's color (~800ms).
export default function PortalTransition({ color = "#FF2A6D" }) {
  return (
    <motion.div
      className="pointer-events-none fixed inset-0 z-[150] flex items-center justify-center overflow-hidden"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="rounded-full"
        style={{ background: color, boxShadow: `0 0 140px 60px ${color}` }}
        initial={{ width: 0, height: 0, opacity: 0.95 }}
        animate={{ width: 3200, height: 3200, opacity: 0 }}
        transition={{ duration: 0.8, ease: "easeIn" }}
      />
    </motion.div>
  );
}
